import * as React from "react";
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Snippets from "../../../../helpers/Snippets";
import axios from "axios";
import ProductSimple from "./Widgets/ProductSimple";
import ProductsSearchResultsList from "./ProductsSearchResultsList";
import Skeleton from "react-loading-skeleton";

export default () => {
  const { slug } = useParams();
  const [resultsFetched, setResultsFetched] = useState(false);
  const [productList, setProductsList] = React.useState([]);
  const [filteredProductList, setFilteredProductsList] = React.useState([]);
  const [pageTitle, setPageTitle] = useState("Products");
  const [dummyArray, setDummyArray] = React.useState([1, 2, 3, 4]);

  useEffect(() => {
    // Determine the API endpoint based on the slug
    let apiUrl = '';
    let title = 'Products';

    switch (slug) {
      case 'new-arrivals':
        apiUrl = Snippets.konstants.BASE_URL_API + '/home/new-arrivals/0/50';
        title = 'New Arrivals';
        break;
      case 'top-ranking':
        apiUrl = Snippets.konstants.BASE_URL_API + '/home/top-ranking/0/50';
        title = 'Top Ranking';
        break;
      case 'analyst-choice':
        apiUrl = Snippets.konstants.BASE_URL_API + '/home/analyst-choice/0/50';
        title = "Analyst's Choice";
        break;
      case 'low-moq':
        apiUrl = Snippets.konstants.BASE_URL_API + '/home/low-moq/0/50';
        title = 'Low MOQ';
        break;
      case 'featured':
        apiUrl = Snippets.konstants.BASE_URL_API + '/home/featured/0/50';
        title = 'Featured Products';
        break;
      default:
        // Try to fetch by category or other criteria
        apiUrl = Snippets.konstants.BASE_URL_API + '/home/search-products/0/50/' + slug;
        title = slug.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    }

    setPageTitle(title);

    var config = {
      method: 'get',
      url: apiUrl,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    };

    axios(config).then(({ data: products }) => {
      setResultsFetched(true);
      if (products) {
        setProductsList(products);
        setFilteredProductsList(products);
      }
    }).catch((error: any) => {
      setResultsFetched(true);
      console.error("Error fetching products:", error);
    });
  }, [slug]);

  return (
    <>
      {resultsFetched ? (
        <>
          <div className="breadcrumb-container container">
            <h4 className="mt-5">{pageTitle}</h4>
            <p>Showing {productList.length} products</p>
          </div>

          <main id="main" className="main mb-10 pb-1" style={{
            backgroundColor: 'rgb(245,245,245)', padding: '20px 0'
          }}>
            <div className="page-content">
              <div className="container">
                <div className="row gutter-lg">
                  <div className="main-content">
                    {productList.length > 0 ? (
                      <ProductsSearchResultsList productList={filteredProductList} />
                    ) : (
                      <div className="no-results mt-5">
                        <p>No products found.</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </main>
        </>
      ) : (
        <>
          <div className="breadcrumb-container container">
            <div className="row">
              <div className="col-md-3 mt-3">
                <Skeleton count={1} height={15} />
                <Skeleton count={1} height={12} />
              </div>
            </div>
          </div>

          <main id="main" className="main mb-10 pb-1" style={{
            backgroundColor: 'rgb(245,245,245)', padding: '20px 0'
          }}>
            <div className="page-content">
              <div className="container">
                <div className="row gutter-lg">
                  <div className="main-content">
                    <div className="row mb-3">
                      <div className="col-md-4">
                        <Skeleton count={1} height={20} />
                      </div>
                    </div>

                    <div className="row cols-xl-4 cols-lg-4 cols-md-4 cols-sm-4 cols-4">
                      {dummyArray.map(() => (
                        <div className="swiper-slide category-wrap mt-20" style={{ marginBottom: "20px" }}>
                          <div className="category category-classic category-absolute overlay-zoom br-sm" style={{ padding: "10px" }}>
                            <Skeleton count={1} height={98} />
                            <Skeleton count={1} height={32} />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </>
      )}
    </>
  );
};
